<template>
  <div id="engineering" class="engineering pt-5 mt-5">
    <div
      class="mdc-layout-grid__inner section-team-developers target-team-developers animate-team-developers"
    >
      <div
        class="engineering-gif-left mdc-layout-grid__cell hero-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-4-phone position-relative"
      >
        <span class="artwork"
          >Art by
          <a
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://dribbble.com/guillaumekurkdjian"
            >Guillaume Kurkdjian</a
          ></span
        >
      </div>
      <div
        class="mdc-layout-grid__cell hero-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone"
      >
        <div class="text-center mt-5 mx-auto col-lg-9 py-md-6-fluid">
          <h2
            :data-text="$t('title')"
            data-aos="zoom-out-down"
            data-aos-delay="300"
            data-aos-duration="500"
            class="mdc-typography--headline2 font-weight-bold engineering-h2 engineering-title glitch-animation anim-repeat"
          >
            {{ $t('title') }}
          </h2>
          <h2
            :data-text="$t('title2')"
            data-aos="zoom-out-up"
            data-aos-delay="300"
            data-aos-duration="500"
            class="mdc-typography--headline2 font-weight-bold engineering-h2 engineering-subtitle glitch-animation anim-repeat anim-delay"
          >
            {{ $t('title2') }}
          </h2>
          <p
            class="mdc-typography--headline6 font-weight-bold engineering-p mb-0"
          >
            {{ $t('subtitle') }}
          </p>
          <div class="hora"></div>
        </div>
      </div>
      <div
        class="team-graph-right mdc-layout-grid__cell hero-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-1-phone position-relative"
      >
        <figure
          class="d-flex align-items-center justify-content-center position-absolute engineering-logo engineering-logo--vue"
        >
          <a
            href="https://www.vuejs.org"
            class="tech-logo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              data-aos="zoom-in"
              data-aos-delay="2900"
              data-aos-duration="500"
              src="/img/logos/vue.svg"
              alt="VueJS logo"
              class="box-shadow-large rounded-2 engineering-img"
              loading="lazy"
          /></a>
          <figcaption class="logo-tooltip">
            <div class="px-2 py-1 text-center mdc-typography--body2">
              VueJS
            </div>
          </figcaption>
        </figure>
        <figure
          class="d-flex align-items-center justify-content-center position-absolute engineering-logo engineering-logo--elrond"
        >
          <a
            href="https://www.elrond.com"
            class="tech-logo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              data-aos="zoom-in"
              data-aos-delay="2800"
              data-aos-duration="500"
              src="/img/logos/elrond.svg"
              alt="Elrond Network logo"
              class="box-shadow-large rounded-2 engineering-img"
              loading="lazy"
            />
          </a>
          <figcaption class="logo-tooltip">
            <div class="px-2 py-1 text-center mdc-typography--body2">
              Elrond Network
            </div>
          </figcaption>
        </figure>
        <figure
          class="d-flex align-items-center justify-content-center position-absolute engineering-logo engineering-logo--stripe"
        >
          <a
            href="https://www.stripe.com"
            class="tech-logo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              data-aos="zoom-in"
              data-aos-delay="2700"
              data-aos-duration="500"
              src="/img/logos/stripe.png"
              alt="Stripe logo"
              class="box-shadow-large rounded-2 engineering-img p-0"
              loading="lazy"
            />
          </a>
          <figcaption class="logo-tooltip">
            <div class="px-2 py-1 text-center mdc-typography--body2">
              Stripe
            </div>
          </figcaption>
        </figure>
        <figure
          class="d-flex align-items-center justify-content-center position-absolute engineering-logo engineering-logo--django"
        >
          <a
            href="https://www.djangoproject.org"
            class="tech-logo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              data-aos="zoom-in"
              data-aos-delay="2600"
              data-aos-duration="500"
              src="/img/logos/django.png"
              alt="Django Framework logo"
              class="box-shadow-large rounded-2 engineering-img p-0"
              loading="lazy"
            />
          </a>
          <figcaption class="logo-tooltip">
            <div class="px-2 py-1 text-center mdc-typography--body2">
              Django Framework
            </div>
          </figcaption>
        </figure>
        <figure
          class="d-flex align-items-center justify-content-center position-absolute engineering-logo engineering-logo--azure"
        >
          <a
            href="https://www.azure.microsoft.com"
            class="tech-logo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              data-aos="zoom-in"
              data-aos-delay="2500"
              data-aos-duration="500"
              src="/img/logos/microsoft_azure.svg"
              alt="Microsoft Azure logo"
              class="box-shadow-large rounded-2 engineering-img"
              loading="lazy"
          /></a>
          <figcaption class="logo-tooltip">
            <div class="px-2 py-1 text-center mdc-typography--body2">
              Microsoft Azure Cloud
            </div>
          </figcaption>
        </figure>
        <figure
          class="d-flex align-items-center justify-content-center position-absolute engineering-logo engineering-logo--github"
        >
          <a
            href="https://www.github.com"
            class="tech-logo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              data-aos="zoom-in"
              data-aos-delay="2400"
              data-aos-duration="500"
              src="/img/logos/github.png"
              alt="GitHub logo"
              class="box-shadow-large rounded-2 engineering-img"
              loading="lazy"
          /></a>
          <figcaption class="logo-tooltip">
            <div class="px-2 py-1 text-center mdc-typography--body2">
              GitHub
            </div>
          </figcaption>
        </figure>
        <figure
          class="d-flex align-items-center justify-content-center position-absolute engineering-logo engineering-logo--material"
        >
          <a
            href="https://www.material.io"
            class="tech-logo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              data-aos="zoom-in"
              data-aos-delay="2300"
              data-aos-duration="500"
              src="/img/logos/material.svg"
              alt="Material Design logo"
              class="box-shadow-large rounded-2 engineering-img"
              loading="lazy"
          /></a>
          <figcaption class="logo-tooltip">
            <div class="px-2 py-1 text-center mdc-typography--body2">
              Material Design
            </div>
          </figcaption>
        </figure>
      </div>
    </div>

    <!-- Posts -->
    <div
      class="mdc-layout-grid mdc-container mt-5 pt-5"
      style="margin-top: 150px !important;"
    >
      <div class="mdc-layout-grid__inner" id="posts">
        <div
          v-bind:class="[activeClass, errorClass]"
          class="mdc-layout-grid__cell story-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone"
          v-for="item in items"
          :key="item.id"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content overflow-visible p-3 pb-5">
            <div class="blog-post--author">
              <img src="/img/changelog/mateesville.jpg" alt="Matei" />
            </div>
            <div class="blog-post--date">{{ item.date }}</div>
            <h6 class="mdc-typography--headline6 text-color">
              {{ item.author }}
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              {{ item.title }}
            </p>
            <p class="mdc-typography--body2 text-color line-clamp">
              {{ item.short_description }}
            </p>
            <div class="chips">
              <a
                class="chip"
                v-for="tag in item.tags"
                :key="tag.id"
                :href="'/engineering/tags/' + tag"
                >{{ tag }}</a
              >
            </div>
            <button class="mdc-button mdc-button--outlined mt-auto">
              <span class="mdc-button__ripple"></span> Read More
            </button>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 1 -->
      </div>
      <!-- Blog Categories -->
      <ul class="nav justify-content-center mt-5 mb-5">
        <li
          class="nav-item"
          v-for="(section, index) in Object.keys(entries)"
          :key="index"
        >
          <a
            class="nav-link active"
            aria-current="page"
            :href="'/engineering/' + section"
            >{{ section }} {{ entries[section].length }}</a
          >
        </li>
      </ul>
      <!-- Blog Posts -->
      <div class="sections">
        <div
          v-for="(section, index) in Object.keys(entries)"
          :key="index"
          class="group"
        >
          <h2 class="left text-uppercase">
            {{ section }}
          </h2>
          <h2 v-if="!entries[section].length" class="mdc-typography--body2">
            Noi povești așteaptă să fie spuse. Deocamdată e liniște...
          </h2>
          <div
            class="section"
            v-for="entry in entries[section]"
            :key="entry.id"
          >
            <div class="entry">
              <div class="entry-date">{{ entry.date }}</div>
              <h3 @click="$router.push({ name: entry.id })">
                {{ entry.title }}
              </h3>
              <p>{{ entry.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- END Blog Posts -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.center {
  text-align: center;
}
.headline {
  text-transform: uppercase;
  margin: 4rem auto;
  font-size: 4rem;
}

h3 {
  // color: #42b883;
  margin-bottom: 0;
  cursor: pointer;
  font-family: Roboto, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 400;
  letter-spacing: 0.03125em;
  text-decoration: inherit;
  text-transform: inherit;
  color: #212121;
  margin: 0;
  letter-spacing: 0;
  text-decoration: underline;
  font-weight: bold;
  font-size: 1rem;
  &:hover {
    text-decoration: underline;
  }
}
.entry-date {
  font-family: 'Roboto Mono', monospace;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0;
  text-decoration: none;
  text-transform: uppercase;
  margin-top: 1.5rem;
  margin-bottom: 0.25rem;
  color: #616161;
  margin: 24px 16px 4px 0;
  font-weight: 400;
  letter-spacing: normal;
  line-height: 1.25rem;
}
</style>

<script>
import BLOGENTRIES from '@/statics/data/blogs.json'

export default {
  name: 'Engineering',
  el: '#posts',
  computed: {
    entries() {
      return BLOGENTRIES
    }
  },
  props: {
    spanDesktop: {
      type: String,
      default: 'plmg'
    },
    spanTablet: {
      type: String,
      default: ''
    },
    spanPhone: {
      type: String,
      default: ''
    }
  },
  metaInfo() {
    return {
      title: this.$t('page_title') || 'Default',
      titleTemplate: '%s | Surfverse',
      meta: [{ name: 'description', content: this.$t('description') }]
    }
  },
  data: function() {
    return {
      items: [
        {
          author: this.$t('post1.author'),
          title: this.$t('post1.title'),
          short_description: this.$t('post1.short_description'),
          description: this.$t('post1.description'),
          date: this.$t('post1.date'),
          desktop: 3,
          tags: [
            this.$t('post1.tags.tag1'),
            this.$t('post1.tags.tag2'),
            this.$t('post1.tags.tag3')
          ]
        },
        {
          author: this.$t('post2.author'),
          title: this.$t('post2.title'),
          short_description: this.$t('post2.short_description'),
          description: this.$t('post2.description'),
          date: this.$t('post2.date'),
          desktop: 3,
          tags: [
            this.$t('post2.tags.tag1'),
            this.$t('post2.tags.tag2'),
            this.$t('post2.tags.tag3')
          ]
        },
        {
          author: this.$t('post3.author'),
          title: this.$t('post3.title'),
          short_description: this.$t('post3.short_description'),
          description: this.$t('post3.description'),
          date: this.$t('post3.date'),
          desktop: 3,
          tags: [
            this.$t('post3.tags.tag1'),
            this.$t('post3.tags.tag2'),
            this.$t('post3.tags.tag3')
          ]
        },
        {
          author: this.$t('post4.author'),
          title: this.$t('post4.title'),
          short_description: this.$t('post4.short_description'),
          description: this.$t('post4.description'),
          date: this.$t('post4.date'),
          desktop: 3,
          tags: [
            this.$t('post4.tags.tag1'),
            this.$t('post4.tags.tag2'),
            this.$t('post4.tags.tag3')
          ]
        }
      ]
    }
  }
}
</script>
<i18n>
{
  "en": {
    "title": "Surfverse",
    "title2": "Engineering",
    "subtitle": "Stories from the people who build it",
    "page_title": "Engineering Blog",
    "meta_description": "News about Infrastructure Systems, Open Source and Developer Tools.",
    "post1": {
      "author": "@mateesville",
      "title": "Getting started with Python and Django at Surfverse",
      "short_description": "Django is a high-level Python Web framework that encourages rapid development and clean, pragmatic design. Built by experienced developers, it takes care of much of the hassle of Web development, so you can focus on writing your app without needing to reinvent the wheel. It’s free and open source.",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "date": "09/07/2020",
      "tags": {
        "tag1": "Django",
        "tag2": "Python",
        "tag3": "Starter"
      }
    },
    "post2": {
      "author": "@matei",
      "title": "How @surfverse started",
      "short_description": "Surfverse was developed in Medgidia by Bogdan Mateescu. Bogdan was working in web design and started his Computer Science course on edX.org, doing engineering at night to help him learn how to code. He created a prototype app of an idea he originally called Diesel, which allowed entrepreneurs to check-in where they are and meet others hackers nearby. Now @surfverse is a home for entrepreneurs and has a lot of new features.",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "date": "09/12/2020",
      "tags": {
        "tag1": "Entrepreneurship",
        "tag2": "Story",
        "tag3": "Medgidia"
      }
    },
    "post3": {
      "author": "@matei",
      "title": "How we manage containers",
      "short_description": "Containers are an abstraction at the app layer that packages code and dependencies together. Multiple containers can run on the same machine and share the OS kernel with other containers, each running as isolated processes in user space. Containers take up less space than VMs (container images are typically tens of MBs in size), can handle more applications and require fewer VMs and Operating systems.",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "date": "09/18/2020",
      "tags": {
        "tag1": "Docker",
        "tag2": "Containers",
        "tag3": "Registry"
      }
    },
    "post4": {
      "author": "@design",
      "title": "Designing at @surfverse",
      "short_description": "Short intro about fourth post",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "date": "09/21/2020",
      "tags": {
        "tag1": "Design",
        "tag2": "Material",
        "tag3": "Guidelines"
      }
    }
  },
  "ro": {
    "title": "Surfverse",
    "title2": "Engineering",
    "subtitle": "Povești de la oamenii care îl construiesc",
    "page_title": "Blog de inginerie",
    "meta_description": "Surfverse Blog de inginerie",
    "post1": {
      "author": "@mateesville",
      "title": "Getting started with Python and Django at Surfverse",
      "short_description": "Django is a high-level Python Web framework that encourages rapid development and clean, pragmatic design. Built by experienced developers, it takes care of much of the hassle of Web development, so you can focus on writing your app without needing to reinvent the wheel. It’s free and open source.",
      "description": "Why Django? Because is Ridiculously fast. Django was designed to help developers take applications from concept to completion as quickly as possible.",
      "date": "07.09.2020",
      "tags": {
        "tag1": "Django",
        "tag2": "Python",
        "tag3": "Starter"
      }
    },
    "post2": {
      "author": "@matei",
      "title": "How @surfverse started",
      "short_description": "Surfverse was developed in Medgidia by Bogdan Mateescu. Bogdan was working in web design and started his Computer Science course on edX.org, doing engineering at night to help him learn how to code. He created a prototype app of an idea he originally called Diesel, which allowed entrepreneurs to check-in where they are and meet others hackers nearby. Now @surfverse is a home for entrepreneurs and has a lot of new features.",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "date": "12.09.2020",
      "tags": {
        "tag1": "Entrepreneurship",
        "tag2": "Story",
        "tag3": "Medgidia"
      }
    },
    "post3": {
      "author": "@matei",
      "title": "How we manage containers",
      "short_description": "Containers are an abstraction at the app layer that packages code and dependencies together. Multiple containers can run on the same machine and share the OS kernel with other containers, each running as isolated processes in user space. Containers take up less space than VMs (container images are typically tens of MBs in size), can handle more applications and require fewer VMs and Operating systems.",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "date": "18.09.2020",
      "tags": {
        "tag1": "Docker",
        "tag2": "Containers",
        "tag3": "Registry"
      }
    },
    "post4": {
      "author": "@design",
      "title": "Designing at @surfverse",
      "short_description": "How we ship great user experience using material design system",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "date": "21.09.2020",
      "tags": {
        "tag1": "Design",
        "tag2": "Material",
        "tag3": "Guidelines"
      }
    }
  }
}
</i18n>
<style lang="scss" scoped>
.center {
  text-align: center;
}
.headline {
  text-transform: uppercase;
  margin: 4rem auto;
  font-size: 4rem;
}
// img {
//   display: block;
//   margin: 0 auto;
//   width: 150px;
// }

h3 {
  color: #42b883;
  margin-bottom: 0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  .subtitle {
    color: grey;
    font-size: 0.98rem;
    float: right;
    font-weight: normal;
  }
}

p {
  margin-top: 0.4rem;
}

.sections {
  max-width: 40vw;
  margin: 0 auto;
  margin-top: 4rem;
}

.section {
  margin-bottom: 3rem;
}

.group {
  margin-bottom: 4rem;
}
</style>
<style>
.chips {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
}
.chip {
  background-color: var(--material-chip-bg);
  border: var(--material-chip-border);
  border-radius: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: var(--material-chip-text);
  display: block;
  font-size: 14px;
  height: 32px;
  line-height: 30px;
  margin: 0 8px 12px 0;
  overflow: hidden;
  padding: 0 12px;
  text-decoration: none;
  -webkit-transition: background-color 0.2s, border 0.2s;
  transition: background-color 0.2s, border 0.2s;
}
.artwork {
  transform: var(--engineering-artwork);
  bottom: -24px;
  font-size: 12px;
  left: 24px;
  background: transparent;
  padding: 2px 8px;
  border-radius: 20px;
  opacity: 0.5;
}
.artwork:hover {
  opacity: 1;
}
div#app.router-engineering {
  background-color: var(--engineering-bg) !important;
}
/* div#app.router-home {
  background-color: #1b1 !important;
} */
.overflow-visible {
  overflow: visible !important;
}
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.blog-post--date {
  font-family: 'Roboto Mono', Roboto, Arial, monospace;
  font-weight: 400;
  color: #5f6368;
  font-size: 0.875rem;
  font-style: normal;
  line-height: 1.25rem;
  letter-spacing: 0;
}
.blog-post--author {
  width: 64px;
  height: 64px;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
}
.card-content .blog-post--author img {
  display: inline;
  margin: 0 auto;
  height: 64px;
  width: auto;
}
.hora:hover {
  animation-name: shake;
  animation-iteration-count: 5;
}
.hora {
  height: 190px;
  max-height: 150px;
  background-image: url(/img/logos/taranca.svg);
  background-repeat: repeat-x;
  background-size: contain;
  background-repeat: space;
  background-size: 88px auto;
}
@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
/* .about {
  margin-top: 150px !important;
} */
.story-cell {
  background: var(--grid-cell) !important;
  border: var(--grid-cell-border);
  height: 62.56vh;
  min-height: 500px;
}
.engineering-h2 {
  line-height: 0.96;
  letter-spacing: -0.01em !important;
  text-transform: uppercase;
  font-family: Oswald;
}
.engineering-p {
  font-size: 1.19rem;
}
.engineering-img {
  padding: 12px;
  width: 80px;
  height: auto;
}
.engineering-logo--python {
  top: 0;
  right: 40%;
}
.engineering-logo--docker {
  top: 19%;
  right: 20%;
}
.engineering-logo--postgres {
  top: 19%;
  right: 66%;
}
.engineering-logo--firebase {
  top: 39%;
  right: 30%;
  display: block;
}
.engineering-logo--kubernetes {
  top: 46%;
  right: 73%;
}
.engineering-logo--redis {
  top: 60%;
  right: 60%;
}
.engineering-logo--traefik {
  top: 70%;
  right: 10%;
}
.engineering-logo--elastic {
  top: 85%;
  right: 40%;
}

.engineering-logo--vue {
  top: 0;
  left: 40%;
}
.engineering-logo--elrond {
  top: 19%;
  left: 20%;
}
.engineering-logo--stripe {
  top: 14%;
  left: 66%;
}
.engineering-logo--django {
  top: 39%;
  left: 30%;
}
.engineering-logo--azure {
  top: 46%;
  left: 73%;
}
.engineering-logo--material {
  top: 64%;
  left: 40%;
}
.engineering-logo--github {
  top: 83%;
  left: 25%;
}
.engineering-logo {
  width: 4.75rem;
  padding: 12px;
  min-height: 4.75rem;
}
.box-shadow-large {
  box-shadow: 0 8px 24px rgba(149, 157, 165, 0.2) !important;
  background: var(--mdc-theme-on-surface);
}
.rounded-2 {
  border-radius: 6px !important;
}
.engineering-gif-left {
  /* background-image: url(/img/engineering/coding.gif); */
  background-image: var(--engineering-gif);
  background-size: var(--engineering-gif-size);
  background-position: var(--engineering-gif-position);
  background-repeat: no-repeat;
  transform: var(--engineering-gif-transform);
  transition: background-image 1000ms linear;
}

/* .target-team-developers .engineering-logo {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
} */
/* .engineering-gif-left {
  bottom: 0;
  height: 10rem;
  background-image: linear-gradient(
      hsla(0, 0%, 100%, 0.9),
      hsla(0, 0%, 100%, 0.9)
    ),
    url(https://github.githubassets.com/images/modules/site/team/team-contrib-graph-left.svg);
  background-repeat: repeat-x;
  background-position: top;
  background-size: 50vh;
}
#engineering .grid-cell {
  background: transparent !important;
} */
/* 
.animate-team-developers .engineering-logo:first-child {
  opacity: 1;
  transition-delay: 0.2s;
  animation-name: team-animation-pop;
  animation-duration: 0.2s;
  animation-delay: 0.2s;
}
.animate-team-developers .engineering-logo:nth-child(2) {
  opacity: 1;
  transition-delay: 0.4s;
  animation-name: team-animation-pop;
  animation-duration: 0.2s;
  animation-delay: 0.4s;
}
.animate-team-developers .engineering-logo:nth-child(3) {
  opacity: 1;
  transition-delay: 0.6s;
  animation-name: team-animation-pop;
  animation-duration: 0.2s;
  animation-delay: 0.6s;
}
.animate-team-developers .engineering-logo:nth-child(4) {
  opacity: 1;
  transition-delay: 0.8s;
  animation-name: team-animation-pop;
  animation-duration: 0.2s;
  animation-delay: 0.8s;
}
.animate-team-developers .engineering-logo:nth-child(5) {
  opacity: 1;
  transition-delay: 1s;
  animation-name: team-animation-pop;
  animation-duration: 0.2s;
  animation-delay: 1s;
}
.animate-team-developers .engineering-logo:nth-child(6) {
  opacity: 1;
  transition-delay: 1.2s;
  animation-name: team-animation-pop;
  animation-duration: 0.2s;
  animation-delay: 1.2s;
}
.animate-team-developers .engineering-logo:nth-child(7) {
  opacity: 1;
  transition-delay: 1.4s;
  animation-name: team-animation-pop;
  animation-duration: 0.2s;
  animation-delay: 1.4s;
}
.animate-team-developers .engineering-logo:nth-child(8) {
  opacity: 1;
  transition-delay: 1.6s;
  animation-name: team-animation-pop;
  animation-duration: 0.2s;
  animation-delay: 1.6s;
}

@keyframes team-animation-pop {
  0% {
    transform: scaleX(1);
  }
  50% {
    transform: scale3d(1.12, 1.12, 1.12);
  }
  100% {
    transform: scaleX(1);
  }
} */

.engineering-logo:hover .logo-tooltip {
  opacity: 0.9;
  transform: scaleY(1);
}
.logo:hover .logo-tooltip {
  opacity: 0.9;
  transform: scaleY(1);
}
.engineering-logo .logo-tooltip {
  position: absolute;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  white-space: nowrap;
  border-radius: 16px;
  background-color: var(--background-color);
  color: var(--text-color);
  font-size: 0.9rem;
  z-index: 999;
  bottom: -2.425rem;
  box-shadow: 0 0.3125rem 0.625rem 0 rgba(4, 125, 220, 0.07);
  transform: scaleY(0);
  transform-origin: top;
  transition: opacity 0.1s ease-out, transform 0.1s ease-out;
  opacity: 0;
  pointer-events: none;
}
.logo .logo-tooltip {
  position: absolute;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  white-space: nowrap;
  border-radius: 16px;
  background-color: var(--background-color);
  color: var(--text-color);
  font-size: 0.9rem;
  z-index: 999;
  bottom: -2.425rem;
  box-shadow: 0 0.3125rem 0.625rem 0 rgba(4, 125, 220, 0.07);
  transform: scaleY(0);
  transform-origin: top;
  transition: opacity 0.1s ease-out, transform 0.1s ease-out;
  opacity: 0;
  pointer-events: none;
}
/* #app {
  background-image: url(https://media1.giphy.com/media/4rW9yu8QaZJFC/giphy.gif?cid=ecf05e4…&rid=giphy.gif);
  background-position: center;
  background-size: contain;
} */
figure[role='img-logo']:nth-child(1) {
  animation-delay: 0s;
}
figure[role='img-logo']:nth-child(2) {
  animation-delay: -2s;
}
figure[role='img-logo']:nth-child(3) {
  animation-delay: -1s;
}
figure[role='img-logo']:nth-child(4) {
  animation-delay: -3s;
}
figure[role='img-logo']:nth-child(5) {
  animation-delay: -2s;
}
figure[role='img-logo']:nth-child(6) {
  animation-delay: -4s;
}
figure[role='img-logo']:nth-child(7) {
  animation-delay: -4s;
}
figure[role='img-logo']:nth-child(8) {
  animation-delay: -6s;
}
figure[role='img-logo']:nth-child(9) {
  animation-delay: -3s;
}
figure[role='img-logo']:nth-child(10) {
  animation-delay: 0s;
}
figure[role='img-logo'] {
  position: absolute;
  width: 120px;
  height: 120px;
  animation-name: b;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: both;
}
.image-logo-item1 {
  background-image: url(/img/about/logos/docker.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 120px;
  top: 23%;
  right: 23%;
}
.image-logo-item2 {
  background-image: url(/img/about/logos/postgres.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100px;
  right: 85%;
  bottom: 28%;
}
.image-logo-item3 {
  background-image: url(/img/about/logos/python.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100px;
  left: 40%;
  bottom: 40%;
}
.image-logo-item4 {
  background-image: url(/img/about/logos/django-logo-negative.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 120px;
  left: 51%;
  bottom: 40%;
  animation-delay: 2s;
}
.image-logo-item5 {
  background-image: url(/img/about/logos/kub8.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 200px;
  width: 220px !important;
  height: 100px !important;
  left: 2%;
  bottom: 4%;
}
.image-logo-item6 {
  background-image: url(/img/about/logos/traefik.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 120px;
  left: 5%;
  top: 20%;
}
.image-logo-item7 {
  background-image: url(/img/about/logos/sentry.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 110px;
  left: 80%;
  top: 3%;
}
.image-logo-item8 {
  background-image: url(/img/about/logos/elastic.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 70px;
  left: 73%;
  bottom: 8%;
}
.image-logo-item9 {
  background-image: url(/img/about/logos/vue.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 70px;
  left: 85%;
  bottom: 28%;
}
.image-logo-item10 {
  background-image: url(/img/about/logos/firebase.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 70px;
  right: 73%;
  bottom: 8%;
}
.tech-logo-link {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
.gallery-landing-image-wrapped:nth-child(8n-6)
  .gallery-landing-image-caption-content {
  background: #2d646e;
}
.gallery-landing-image-wrapped:hover .gallery-landing-image-caption-content {
  opacity: 1;
  pointer-events: auto;
  transform: scale(1) rotateX(0deg);
  transition: opacity 0s linear 0.25s;
}
.gallery-landing-image-caption-content {
  padding: 0.7em 1.2em;
  box-shadow: 0.5rem 2rem 4rem rgba(0, 0, 0, 0.3);
  background: red;
  font-size: 0.8em;
  line-height: 1.35;
  opacity: 0;
  transform: scale(0.8) rotateX(0deg);
  transition: all 0.25s ease-in-out;
}
.gallery-landing-image-caption-bottom {
  top: auto;
  bottom: 3vh;
}
@keyframes b {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.hero-cell {
  height: 45vh;
  max-height: 45vh;
}

@media (max-width: 576px) {
  .python {
    width: 42px !important;
    height: 42px;
  }
  .engineering-logo--python {
    top: 0;
    right: -45%;
  }
  .engineering-logo--docker {
    top: 19%;
    right: 0%;
  }
  .engineering-logo--postgres {
    top: 30%;
    right: 39%;
  }
  .engineering-logo--firebase {
    top: 43%;
    right: -12%;
    display: block;
  }
  .engineering-logo--kubernetes {
    top: 60%;
    right: 60%;
  }
  .engineering-logo--redis {
    top: 70%;
    right: -20%;
  }
  .engineering-logo--traefik {
    top: 80%;
    right: -100%;
  }
  .engineering-logo--elastic {
    top: 85%;
    right: 25%;
  }

  .engineering-logo--vue {
    top: 0;
    left: -145%;
  }
  .engineering-logo--elrond {
    top: 19%;
    left: 20%;
  }
  .engineering-logo--stripe {
    top: 14%;
    left: 66%;
  }
  .engineering-logo--django {
    top: 0%;
    left: -45%;
  }
  .engineering-logo--azure {
    top: 46%;
    left: 73%;
  }
  .engineering-logo--material {
    top: 64%;
    left: 40%;
  }
  .engineering-logo--github {
    top: 83%;
    left: 25%;
  }
  .engineering-logo {
    width: 42px;
    padding: 0;
    min-height: 42px;
  }
  .engineering-img {
    width: 32px;
    padding: 0;
  }
  .box-shadow-large {
    box-shadow: unset !important;
    background: transparent;
  }
  .engineering-title {
    font-size: 32px;
  }
  .engineering-subtitle {
    font-size: 28px;
  }
  .engineering-p {
    font-size: 14px;
  }
  .mdc-typography--headline6 {
    line-height: 1rem;
  }
  .hora {
    height: 80px;
    max-height: 80px;
    background-size: 38px auto;
    margin-top: 12px;
  }
  .hero-cell {
    height: 23vh;
    max-height: 20vh;
    background-size: contain;
    background-position: center;
  }
}
.anim-repeat::after,
.anim-repeat::before {
  animation-iteration-count: 1 !important;
}
.anim-delay::before,
.anim-delay::after {
  animation-delay: 1s;
}
</style>
